import Close from "@mui/icons-material/Close";
import { IconButton, DialogTitle as MuiDialogTitle, styled } from "@mui/material";
import clsx from "clsx";
import React from "react";
const classes = { root: "dialog-title-root" };
const StyledMuiDialogTitle = styled(MuiDialogTitle, { shouldForwardProp: (prop) => prop !== "closeButton" })(({ closeButton, theme }) => ({
    [`&.${classes.root}`]: {
        borderBottom: `1px solid ${theme.palette.border.main}`,
        boxShadow: "0 2px 12px 0 rgba(0, 0, 0, 0.1)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: `${closeButton ? "16px 30px" : "20px 30px"} `,
        fontSize: theme.typography.pxToRem(18),
        fontWeight: 600
    }
}));
export const DialogTitle = ({ children, closeButton, onClose, className, style, ...other }) => {
    return (React.createElement(StyledMuiDialogTitle, { ...other, closeButton: true, className: clsx(classes.root, className), style: style },
        children,
        closeButton ? (React.createElement(IconButton, { "aria-label": "close", onClick: onClose, sx: { padding: "5px", margin: "0 -5px 0 10px" }, size: "large" },
            React.createElement(Close, null))) : null));
};
//Prop defaults
DialogTitle.defaultProps = {
    closeButton: false
};
